import React, { useEffect, useState } from 'react';
import InputField from '../../../component/form/FormInput';
import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../component/ui/Button';
import InputSelect from '../../../component/inputSelect/InputSelect';
import AdjustmentTable from './AdjustmentTable';
import { useDispatch, useSelector } from 'react-redux';
import pdfMake from 'pdfmake/build/pdfmake';
import {
	getRefNumber,
	inventoryAdjustmentConvert,
	inventoryAdjustmentCreate,
	inventoryAdjustmentDelete,
	inventoryAdjustmentReverted,
	inventoryAdjustmentUpdate,
} from '../../../store/action/inventory';
import { toast } from 'react-toastify';

import { hasPermission } from '../../../utils/controller';
import ConfirmationModal from '../../../component/modal/ConfirmationModal';
import {
	fetchAdjustmentAccounts,
	fetchInventoryAdjustmentListForDetails,
	fetchReasonList,
	generateInventoryAdjustmentPdf,
} from '../../../services/adjustments';
import { generateAdjustmentPdf } from './components/generateAdjustmentPdf';
import AutoSaveModal from '../../components/autoSaveModal';

const Adjustment = () => {
	const dispatch = useDispatch();
	const today = new Date().toISOString().split('T')[0];
	const navigate = useNavigate();
	const param = useParams();
	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});
	const inventoryAdjustmentId = param?.id;
	const [refnumber, setrefnumber] = useState('');
	const [date, setDate] = useState(today);
	const [account, setAccount] = useState('');
	const [reason, setReason] = useState('');
	const [description, setDescription] = useState('');
	const [tableData, setTableData] = useState([]);
	const [errorCells, setErrorCells] = useState([]);
	const [error, setError] = useState({});
	const [loader, setLoader] = useState({
		isLoading: false,
		status: null,
	});
	const [conversionLoader, setConversionLoader] = useState(false);
	const [inventoryTableError, setInventoryTableError] = useState(false);
	const [reasonOption, setReasonOption] = useState([]);
	const [accountOption, setAcctountOption] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [ModalState, setModalState] = useState({
		title: '',
		content: '',
		handleSubmit: null,
	});
	const [inventoryAdjustmentDetails, setInventoryAdjustmentDetails] = useState();
	const [showModal, setShowModal] = useState(false);
	const [disabled, setDisabled] = useState(inventoryAdjustmentId ? true : false);
	const suburl = localStorage.getItem('suburl');
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isAdjustmentAutoSave, setIsAdjustmentAutoSave] = useState(false);
	const checkValidation = (status) => {
		const newError = { ...error };
		let newErrorCell = [...errorCells];
		if (refnumber === undefined || refnumber === '' || refnumber === null) {
			newError.refnumber = 'Please enter reference number in the field.';
		} else {
			delete newError.refnumber;
		}
		if (account === undefined || account === '' || account === null) {
			newError.account = 'Please select account from the list.';
		} else {
			delete newError.account;
		}
		if (status === 1) {
			if (tableData.length > 0) {
				const adjIndex = Number(tableData.length) - 1;
				if (tableData[adjIndex].product_id === '') {
					newErrorCell = [...newErrorCell, { index: adjIndex, name: 'product_id' }];
				} else {
					delete newError.product_id;
				}
				if (tableData[adjIndex].batch_id === '') {
					newErrorCell = [...newErrorCell, { index: adjIndex, name: 'batch_id' }];
				} else {
					delete newError.batch_id;
				}
				if (
					tableData[adjIndex].quantity_adjusted === null ||
					tableData[adjIndex].quantity_adjusted === '' ||
					Number(tableData[adjIndex].quantity_adjusted) === 0 ||
					Number(tableData[adjIndex].qty) < Number(tableData[adjIndex].quantity_adjusted)
				) {
					newErrorCell = [...newErrorCell, { index: adjIndex, name: 'quantity_adjusted' }];
				} else {
					delete newError.quantity_adjusted;
				}
			} else {
				newErrorCell = [...newErrorCell, { index: 0, name: 'product_id' }];
				newErrorCell = [...newErrorCell, { index: 0, name: 'batch_id' }];
				newErrorCell = [...newErrorCell, { index: 0, name: 'quantity_adjusted' }];
			}
		}

		if (Object.keys(newError).length > 0 || newErrorCell.length > 0) {
			setError(newError);
			setErrorCells(newErrorCell);
			return { status: true, isTableError: newErrorCell.length > 0 };
		} else {
			return { status: false, isTableError: false };
		}
	};

	const saveinventoryAdjust = async (value) => {
		const isError = checkValidation(value);
		if (isError.status) {
			if (isError.isTableError) {
				return toast.error('Error in add inventory table to know more click on show all error.');
			} else {
				return toast.error('Please fill the required fields.');
			}
		} else {
			if (value === 1 && inventoryAdjustmentId) {
				setLoader((prev) => ({
					...prev,
					isLoading: true,
					status: value,
				}));
				var body = {};
				if (disabled === false) {
					let adjustMentDetils = [];
					tableData?.map((ele) => {
						return adjustMentDetils?.push({
							product_id: isNaN(ele?.product_id) ? ele?.product_name : ele?.product_id,
							batch_id: isNaN(ele?.batch_id) ? ele?.batch_no : ele?.batch_id,
							quantity_adjusted: Number(ele?.quantity_adjusted),
						});
					});
					body = {
						adjustment_date: date,
						account_id: account ? Number(account) : '',
						reason_id: reason ? Number(reason) : '',
						description: description,
						is_draft: value,
						adjustment_details: adjustMentDetils,
						reference_number: refnumber,
					};
				}
				dispatch(inventoryAdjustmentConvert(inventoryAdjustmentId, body))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
							setIsLocationBlocker(false);
							setIsAdjustmentAutoSave(false);
							setTimeout(() => {
								navigate(`/user/${suburl}/inventory-adjustment`);
							}, 300);
							setLoader((prev) => ({
								...prev,
								isLoading: false,
								status: null,
							}));
						} else {
							toast.error(res?.message);
							setLoader((prev) => ({
								...prev,
								isLoading: false,
								status: null,
							}));
						}
					})
					.catch((error) => {
						setLoader((prev) => ({
							...prev,
							isLoading: false,
							status: null,
						}));
					});
			} else {
				setLoader((prev) => ({
					...prev,
					isLoading: true,
					status: value,
				}));
				let adjustMentDetils = [];
				tableData?.forEach((ele) => {
					adjustMentDetils?.push({
						product_id: isNaN(ele?.product_id) ? ele?.product_name : ele?.product_id,
						batch_id: isNaN(ele?.batch_id) ? ele?.batch_no : ele?.batch_id,
						quantity_adjusted: Number(ele?.quantity_adjusted),
					});
				});

				const formData = {
					adjustment_date: date,
					account_id: account ? Number(account) : '',
					reason_id: reason ? Number(reason) : '',
					description: description,
					is_draft: value,
					adjustment_details: adjustMentDetils,
					reference_number: refnumber,
				};
				dispatch(inventoryAdjustmentCreate(formData))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
							setIsLocationBlocker(false);
							setIsAdjustmentAutoSave(false);
							setTimeout(() => {
								navigate(`/user/${suburl}/inventory-adjustment`);
							}, 300);
							setLoader((prev) => ({
								...prev,
								isLoading: false,
								status: null,
							}));
						} else {
							toast.error(res?.message);
							setInventoryTableError(true);
							toast.error(error?.adjustment_details);
							setLoader((prev) => ({
								...prev,
								isLoading: false,
								status: null,
							}));
						}
					})
					.catch((error) => {
						toast.error(error?.response.data.message);
						setLoader((prev) => ({
							...prev,
							isLoading: false,
							status: null,
						}));
					});
			}
		}
	};

	const handledelete = () => {
		dispatch(inventoryAdjustmentDelete(inventoryAdjustmentId)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				navigate(`/user/${suburl}/inventory-adjustment`);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const navigateRouter = (path) => {
		navigate(path);
	};

	const updateInventory = () => {
		let id = inventoryAdjustmentId;
		let adjustMentDetils = [];
		tableData?.forEach((ele) => {
			adjustMentDetils?.push({
				product_id: isNaN(ele?.product_id) ? ele?.product_name : ele?.product_id,
				batch_id: isNaN(ele?.batch_id) ? ele?.batch_no : ele?.batch_id,
				quantity_adjusted: Number(ele?.quantity_adjusted),
				adjustment_details_id: Number(ele?.adjustment_details_id),
			});
		});

		const formData = {
			adjustment_date: date,
			account_id: account ? Number(account) : '',
			reason_id: reason ? Number(reason) : null,
			description: description || '',
			is_draft: 1,
			adjustment_details: adjustMentDetils,
			reference_number: refnumber,
		};
		dispatch(inventoryAdjustmentUpdate(id, formData)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				navigate(`/user/${suburl}/inventory-adjustment`);
			} else {
			}
		});
	};

	async function handlePrintAndDownloadPdf(isPrint) {
		setLoading((prev) => {
			if (isPrint === 'print') {
				return {
					...prev,
					pdf: {
						button: isPrint,
						isLoading: true,
					},
				};
			}

			if (isPrint === 'download') {
				return {
					...prev,
					download: {
						button: isPrint,
						isLoading: true,
					},
				};
			}

			return prev;
		});

		const mergedDocDefinition = await generateAdjustmentPdf(inventoryAdjustmentId);
		if (isPrint) {
			pdfMake.createPdf(mergedDocDefinition).print();
		} else {
			pdfMake.createPdf(mergedDocDefinition).download();
		}

		setLoading((prev) => ({
			...prev,
			pdf: {
				...prev.pdf,
				isLoading: false,
			},
			download: {
				...prev.download,
				isLoading: false,
			},
		}));
	}

	async function handleAdjustmentPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				if (type === 'print') {
					return {
						...prev,
						pdf: {
							button: type,
							isLoading: true,
						},
					};
				}

				if (type === 'download') {
					return {
						...prev,
						download: {
							button: type,
							isLoading: true,
						},
					};
				}

				return prev;
			});
			const pdf_details = await generateInventoryAdjustmentPdf(inventoryAdjustmentId);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `inventory_adjustment_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	const revertAsAdjusted = () => {
		setConversionLoader(true);

		dispatch(inventoryAdjustmentReverted(inventoryAdjustmentId))
			.then((res) => {
				if (res?.success) {
					toast.success(res?.message);
					navigate(`/user/${suburl}/inventory-adjustment`);
					setConversionLoader(false);
				} else {
					toast.error(res?.message);
					setConversionLoader(false);
				}
			})
			.catch((error) => {
				setConversionLoader(false);
			});
	};

	const handleConfirmationModal = (data) => {
		if (data === 'delete') {
			setModalState({
				title: 'Inventory Adjustment',
				content: 'Are you sure want to delete ?',
				handleSubmit: handledelete,
			});
		} else if (data === 'reverted') {
			setModalState({
				title: 'Inventory Adjustment',
				content: 'Are you sure you want to revert this entry?',
				handleSubmit: revertAsAdjusted,
			});
		}
		setShowModal(true);
	};

	const handleAccount = (value) => {
		setAccount(value);
		let newError = { ...error };
		if (value) {
			delete newError.account;
		} else {
			newError.account = 'Please select account from the list';
		}
		setError(newError);
	};
	const handleReason = (value) => {
		setReason(value);
		let newError = { ...error };
		if (value) {
			delete newError.reason;
		} else {
			newError.reason = 'Please select reason from the list';
		}
		setError(newError);
	};

	const initialData = async () => {
		try {
			setTableData([]);
			if (inventoryAdjustmentId) {
				let param = `filterBy=adjustment_id&filterValue=${inventoryAdjustmentId}`;
				let res = await fetchInventoryAdjustmentListForDetails(param);
				if (res?.success) {
					const data = res.data.data.inventoryAdjustment[0];
					let adjusmentdetails = [];
					data?.adjusmentdetails?.forEach((item) => {
						adjusmentdetails?.push({
							product_id: item?.product?.product_name,
							batch_id: item?.product_batch?.batch_no.toString(),
							quantity_adjusted: item?.quantity_adjusted,
							adjustment_details_id: item?.adjustment_details_id,
							batch_no: item?.product_batch_id,
							product_name: item?.product_id,
							qty: item?.product_batch?.quantity,
							qtyHand: `${data.is_draft === 0
								? Number(item?.product_batch?.quantity) - Number(item?.quantity_adjusted)
								: Number(item?.product_batch?.quantity) + Number(item?.quantity_adjusted)
								}`,
						});
					});
					setInventoryAdjustmentDetails(data);
					setrefnumber(data?.reference_number);
					setDate(data?.date);
					setAccount(data?.account_id || '');
					setReason(data?.reason_id || '');
					setDescription(data?.description || '');
					setTableData(adjusmentdetails);
				}
			}

			if (!inventoryAdjustmentId) {
				getRefNumber().then((res) => {
					if (res?.success) {
						setrefnumber(res?.data);
					} else {
					}
				});
			}

			const resAccounts = await fetchAdjustmentAccounts();
			const resReason = await fetchReasonList();
			if (resAccounts.success) {
				const accountList = resAccounts.data.map((acc) => {
					return { key: acc.account_id, value: acc.account_name };
				});
				setAcctountOption(accountList);
			}
			if (resReason.success) {
				const reasonList = resReason.data.map((reason) => {
					return { key: reason.reason_id, value: reason.reason_description };
				});
				setReasonOption(reasonList);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		initialData();
	}, [inventoryAdjustmentId]);

	useBlocker((tx) => {
		if (!inventoryAdjustmentId && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsAdjustmentAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div id="pdf-content">
			<div className="header-position-sticky ">
				<div className="product-pg-header add-product">
					<p>Add New Adjustment</p>
					<div className="add-product-button">
						{disabled === true && inventoryAdjustmentDetails?.is_draft === 0 && (
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
								}
								button="Edit"
								onClick={() => setDisabled(false)}
							/>
						)}
						{disabled === true && (
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Print"
								loader={loading.pdf.isLoading}
								onClick={() => handleAdjustmentPrintAndDownloadPdf('print')}
							/>
						)}
						{disabled === true && (
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Download"
								loader={loading.download.isLoading}
								onClick={() => handleAdjustmentPrintAndDownloadPdf('download')}
							/>
						)}
						{inventoryAdjustmentId &&
							disabled === true &&
							inventoryAdjustmentDetails?.is_draft === 0 && (
								<Button
									type="button"
									className="btn-gray mt-0 px-4"
									disabled={
										!hasPermission('inventory.adjustments.delete', user?.role?.role_permissions)
									}
									button="Delete"
									onClick={() => handleConfirmationModal('delete')}
								/>
							)}

						{disabled === false && !inventoryAdjustmentId && (
							<Button
								type="button"
								className="mt-0 w-100 px-5 btn-primary"
								button="Save as Draft"
								disabled={
									loader.isLoading && loader.status === 0
										? true
										: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
								}
								onClick={() => saveinventoryAdjust(0)}
								loader={loader.isLoading && loader.status === 0}
							/>
						)}
						{disabled === false && inventoryAdjustmentId && (
							<Button
								type="button"
								className="mt-0 w-100 px-5 btn-primary"
								disabled={
									loader.isLoading && loader.status === 0
										? true
										: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
								}
								button="Save as Draft"
								onClick={updateInventory}
							/>
						)}
						{((disabled === false && !inventoryAdjustmentId) ||
							inventoryAdjustmentDetails?.is_draft === 0) && (
								<Button
									type="button"
									className="mt-0 w-100 px-5 btn-primary"
									disabled={
										loader.isLoading && loader.status === 1
											? true
											: inventoryAdjustmentId
												? !hasPermission('inventory.adjustments.edit', user?.role?.role_permissions)
												: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
									}
									button="Convert as Adjusted"
									onClick={() => {
										saveinventoryAdjust(1);
									}}
									loader={loader.isLoading && loader.status === 1}
								/>
							)}
						{inventoryAdjustmentDetails?.is_draft === 1 && (
							<Button
								type="button"
								className="mt-0 w-100 px-5 btn-primary"
								disabled={
									conversionLoader
										? true
										: inventoryAdjustmentId
											? !hasPermission('inventory.adjustments.edit', user?.role?.role_permissions)
											: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
								}
								button="Revert as Adjusted"
								onClick={() => handleConfirmationModal('reverted')}
								loader={conversionLoader}
							/>
						)}
						{
							<Button
								type="button"
								className="mt-0 btn-danger add-pro"
								close
								button=""
								// onClick={() => navigateRouter(`/user/${suburl}/inventory-adjustment`)}
								onClick={() => navigateRouter(-1)}
							/>
						}
					</div>
				</div>
			</div>
			<div className="max-w-1297 px-3 py-3">
				<div className="row">
					<div className="col-6">
						<InputField
							label="Reference Number"
							placeholder="Ref#"
							type="text"
							autoFocus={true}
							onChange={(val) => setrefnumber(val)}
							value={refnumber}
							disabled
							required={true}
						/>
					</div>
					<div className="col-6">
						<InputField
							label="Date"
							placeholder="Enter Date"
							type="date"
							onChange={(val) => setDate(val)}
							value={date}
							autoFocus={disabled ? false : true}
							disabled={disabled}
							required={true}
							error={error?.date}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
						<InputSelect
							label="Account"
							placeholder="Select Account"
							onChange={(value) => handleAccount(value)}
							value={account}
							options={accountOption}
							disabled={disabled}
							required={true}
							error={error?.account}
						/>
					</div>
					<div className="col-6">
						<InputSelect
							label="Reason"
							placeholder="Select Reason"
							onChange={(value) => handleReason(value)}
							value={reason}
							options={reasonOption}
							disabled={disabled}
							error={error?.reason}
						/>
					</div>
				</div>
				<div className="row my-1">
					<div className="col-12">
						<InputField
							label="Description"
							placeholder="Provides notes if any"
							type="text"
							onChange={(val) => setDescription(val)}
							value={description}
							disabled={disabled}
							error={error?.description}
						/>
					</div>
				</div>
			</div>

			<AdjustmentTable
				tableData={tableData}
				setTableData={setTableData}
				errorCells={errorCells}
				setErrorCells={setErrorCells}
				disabled={disabled}
				paramId={inventoryAdjustmentId}
				tableError={inventoryTableError}
			/>

			<div>
				{showModal && (
					<ConfirmationModal
						isOpen={showModal}
						onClose={() => setShowModal(false)}
						onCancel={() => setShowModal(false)}
						onOk={revertAsAdjusted}
						title={ModalState?.title}
						content={ModalState?.content}
						handleSubmit={ModalState?.handleSubmit}
					/>
				)}
				{isAdjustmentAutoSave && (
					<AutoSaveModal
						isOpenModel={isAdjustmentAutoSave}
						setIsOpenModel={setIsAdjustmentAutoSave}
						user={user}
						permission={'inventory.adjustments.create'}
						type={'Adjustment'}
						withoutSave={() => {
							setIsLocationBlocker(false);
							setIsAdjustmentAutoSave(false);
							setTimeout(() => {
								navigate(isNextLocation.nextLocation?.pathname);
							}, 300);
						}}
						saveAsDraft={() => {
							setIsAdjustmentAutoSave(false);
							updateInventory();
						}}
						SaveAsContinue={() => {
							setIsAdjustmentAutoSave(false);
							saveinventoryAdjust(1);
						}}
					/>
				)}
			</div>
		</div>
	);
};

export default Adjustment;
